import React from 'react';
import styled from 'styled-components';
import { SETTINGS, STATES } from 'refactored/features/emergencies/constants';
import BodyColumn from 'refactored/features/emergencies/ui/columns/body-column';
import QuoteText from 'refactored/features/emergencies/ui/texts/quote-text';
import { Tooltip } from '@ontruck/orc';
import TooltipHeader from 'refactored/features/emergencies/ui/texts/tooltip-header';
import { withTranslation } from 'react-i18next';

const ButtonContainer = styled.a`
  display: flex;
  flex-grow: 1;
  gap: 4px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const QuoteColumn = withTranslation('Emergencies')(({ ticket, t }) => {
  const ticketState = ticket.synthetic_state;

  const hasQuote = !!ticket.quote;
  const statesWithInvalidQuotes = [
    STATES.CANCELLED,
    STATES.EXPIRED,
    STATES.OUT_OF_SCOPE,
    STATES.REJECTED,
    STATES.ACCEPTED,
    STATES.DONE,
  ];
  const isQuoteInvalid = statesWithInvalidQuotes.includes(ticketState);
  const isQuoteRejected = hasQuote && [STATES.REJECTED].includes(ticketState);

  return (
    <BodyColumn width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.QUOTE}>
      <ButtonContainer
        href={ticket.quote?.url_detail}
        target="_blank"
        disabled={!hasQuote}
      >
        {hasQuote && !isQuoteRejected && (
          <QuoteText isDeprecated={isQuoteInvalid}>
            {ticket.quote.price.amount} {ticket.quote.price.currency}
          </QuoteText>
        )}
        {hasQuote && isQuoteRejected && (
          <Tooltip
            component={
              <TooltipHeader>{t('quote_rejected_tooltip')}</TooltipHeader>
            }
          >
            <QuoteText isDeprecated={isQuoteInvalid}>
              {ticket.quote.price.amount} {ticket.quote.price.currency}
            </QuoteText>
          </Tooltip>
        )}
      </ButtonContainer>
    </BodyColumn>
  );
});
